module.exports = __webpack_public_path__ + "img/company-points-7.png";